import request from '@/utils/request'

/** 账单列表（8 视图：全部/待审核/审核失败/已完成/未出账/已出账/已逾期/已还款） */
export function billList(data) {
  return request.post('/bill/index', data)
}

/** 录入收款账单：POST order_id paytype_id amount voucher transaction_id in_perform */
export function billAdd(data) {
  return request.post('/bill/add', data)
}

/** 账单详情 */
export function billDetail(id) {
  return request.post('/bill/detail', { id })
}

/** 审核通过：POST id perform_date */
export function billAuditPass(id, performDate) {
  return request.post('/bill/auditPass', { id, perform_date: performDate })
}

/** 审核驳回：POST id audit_remark */
export function billAuditRefuse(id, remark) {
  return request.post('/bill/auditRefuse', { id, audit_remark: remark })
}

/** 分期账单还款：POST id */
export function billRepay(id) {
  return request.post('/bill/repay', { id })
}
